import { SkillsCountByTime } from '../../../../constants/form';
import { assignmentNameValidations } from '../../../../constants/validation';
var formValidator = {
    students: function (_a) {
        var students = _a.students;
        return !!students && students.length > 0;
    },
    skills: function (_a) {
        var skills = _a.skills, duration = _a.duration;
        return !!duration &&
            !!skills &&
            skills.length > 0 &&
            skills.length <= SkillsCountByTime[duration];
    },
    duration: function (_a) {
        var duration = _a.duration;
        return !!duration;
    },
    name: function (_a) {
        var name = _a.name;
        return typeof name === 'string' &&
            assignmentNameValidations.every(function (validation) { return validation.validate(name); });
    },
    dates: function (_a) {
        var dates = _a.dates;
        return (dates === null || dates === void 0 ? void 0 : dates[0]) instanceof Date && (dates === null || dates === void 0 ? void 0 : dates[1]) instanceof Date;
    },
    grade: function (_a) {
        var grade = _a.grade;
        return !!grade;
    },
    domain: function () { return true; },
    cards: function (_a) {
        var cards = _a.cards;
        return !!cards && cards.length > 0;
    },
};
var validateForm = function (data) {
    var keys = Object.keys(data);
    return (keys.length === Object.keys(formValidator).length &&
        keys.every(function (key) {
            return formValidator[key](data);
        }));
};
var getInvalidFields = function (data) {
    var keys = Object.keys(formValidator);
    return keys.filter(function (key) { return !formValidator[key](data); });
};
export { validateForm, getInvalidFields };
